import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../client';
import { SingleTopicResponse, Topic, TopicPagination } from './interface';

export const getTopicList = createAsyncThunk(
  'mediaTopic/getTopicList',
  async ({ user_id, page }: TopicPagination, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<Topic>(
        `/api/media-topic?user_id=${user_id}&page=${page}`
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTopicData = createAsyncThunk(
  'mediaTopic/getTopicData',
  async ({ topicId }: { topicId: number }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<SingleTopicResponse>(
        `/api/media-topic/${topicId}`
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createEditTopic = createAsyncThunk(
  'mediaTopic/createEditTopic',
  async (
    {
      topicId,
      title,
      image,
    }: { topicId?: number; title: string; image?: File | string },
    { rejectWithValue }
  ) => {
    try {
      const request = new FormData();
      request.append('title', title);
      if (image && typeof image !== 'string') {
        request.append(`image`, image);
      }

      var url = 'api/media-topic/';
      if (topicId) {
        url += `edit/${topicId}`;
      } else {
        url += `create`;
      }

      const response = await axiosInstance.post<SingleTopicResponse>(
        url,
        request,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTopic = createAsyncThunk(
  'mediaTopic/deleteTopic',
  async ({ topicId }: { topicId: number }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete<SingleTopicResponse>(
        `api/media-topic/${topicId}`
      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
